import { UploadRow } from './ui';

import { getEndpoint } from './lib';
import { useAppDispatch, useAppSelector } from '@shared/model';
import { ExcelFileNameTypes, selectExcelFiles, setFileName, useAddExcelFileMutation } from '@entities/generation-state';
import { rowsContainerStyle, rowContainerStyle } from './ExcelFiles.tailwind';

const ExcelFiles = () => {
  const { customerFileName, monthFileName, staffFileName } = useAppSelector(selectExcelFiles);

  const dispatch = useAppDispatch();
  const [addFileAsync] = useAddExcelFileMutation();

  const handleAddFileAsync = async (formData: FormData, type: ExcelFileNameTypes) => {
    const endpoint = getEndpoint(type);

    if (formData) {
      const { data: isSuccess } = (await addFileAsync({
        formData,
        endpoint,
      })) as unknown as { data: boolean };

      if (isSuccess) {
        const file = formData.get('file') as File;

        dispatch(
          setFileName({
            file: type,
            filename: file.name,
          })
        );
      }

      return isSuccess;
    }

    return false;
  };

  return (
    <div className="mt-12">
      <h2 className="text-2xl">Choose your files (.xlsx)</h2>
      <div className={rowsContainerStyle}>
        <div className={rowContainerStyle}>
          <UploadRow
            text="Choose a Customer"
            value={customerFileName}
            onUpload={formData => handleAddFileAsync(formData, 'customerFileName')}
          />
        </div>
        <div className={rowContainerStyle}>
          <UploadRow
            text="Choose a Month"
            value={monthFileName}
            onUpload={formData => handleAddFileAsync(formData, 'monthFileName')}
          />
        </div>
        <div className={rowContainerStyle}>
          <UploadRow
            text="Choose a Staff"
            value={staffFileName}
            onUpload={formData => handleAddFileAsync(formData, 'staffFileName')}
          />
        </div>
      </div>
    </div>
  );
};

export default ExcelFiles;
